import {Group} from "lib/api/backend.schemas";
import {useTranslation} from "next-i18next";
import {Box, Typography} from "components/basic-components";
import styles from "./VehicleLimitations.module.scss";
import {InfoDivider} from "components/section-components/reservation/Group";
import React from "react";
import clsx from "clsx";

export const VehicleLimitations = ({group}: {group: Group}) => {
  const {t} = useTranslation(['carlist']);
  return (
    <Box sx={{display: 'flex', flexWrap: 'wrap', textAlign: 'left'}}>
      {group?.drivingExperience ? (
        <Box className={styles.limitationsWrapper}>
          <Typography className={styles.limitationText}>{t('drivingExperience')}:</Typography>
          <Typography className={styles.limitationValue}>{group?.drivingExperience}</Typography>
        </Box>
      ) : null}
      {group?.minAge ? (
        <Box className={styles.limitationsWrapper}>
          {group?.drivingExperience && <InfoDivider />}
          <Typography className={styles.limitationText}>{t('minAge')}</Typography>
          <Typography className={styles.limitationValue}>{group?.minAge}</Typography>
        </Box>
      ) : null}
      {group?.dimension ? (
        <Box sx={{display: 'block', width: '100%'}}>
          <Box className={styles.limitationsWrapper}>
            <Typography
              className={clsx({
                [styles.limitationText]: true,
                [styles.limitationTextWidth]: t('loadDimensions').length + (group?.dimension?.length || 0) > 52
              })}
            >
              {t('loadDimensions')}:
            </Typography>
            <Typography className={styles.limitationValue}>{group?.dimension}</Typography>
          </Box>
        </Box>
      ) : null}
    </Box>
  );
};